<nz-modal
  [(nzVisible)]="isVisible"
  [nzWidth]="'auto'"
  [nzFooter]="null"
  [nzClosable]="false"
  [nzWrapClassName]="nzWrapClassName"
  [nzClassName]="nzClassName"
>
    <div id="product-modal" class="product-modal">
        <div class="product-modal__wrapper">
            <div class="product-modal__button-wrapper">
                <button id="product-modal-close_button" class="product-modal__close-button" (click)="handleClose()">X
                    Fechar</button>
            </div>
            <ng-content></ng-content>
        </div>
    </div>
</nz-modal>
